import React, { useState } from 'react';
import Signup from './Signup';
import { motion, AnimatePresence } from 'framer-motion';

const WelcomeModal: React.FC = () => {
  const [showSignup, setShowSignup] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);

  if (showSignup) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm">
        <div className="w-full max-w-md mx-auto p-0 bg-transparent rounded-2xl shadow-xl flex flex-col items-center relative min-h-[540px]">
          {/* No close button, no outside click to dismiss */}
          <Signup />
        </div>
      </div>
    );
  }

  return (
    <AnimatePresence>
      {!fadeOut && (
        <motion.div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
        >
          <div className="w-full max-w-md mx-auto p-8 bg-white rounded-2xl shadow-xl flex flex-col items-center relative min-h-[540px]">
            <div className="flex flex-col items-center justify-center flex-1 w-full">
              <div className="mb-8 mt-6">
                <div className="flex items-center justify-center mb-6">
                  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M32 8C41.9411 8 50 16.0589 50 26C50 35.9411 41.9411 44 32 44C22.0589 44 14 35.9411 14 26C14 16.0589 22.0589 8 32 8Z" fill="#f43f5e"/>
                    <path d="M32 56C41.9411 56 50 47.9411 50 38C50 28.0589 41.9411 20 32 20C22.0589 20 14 28.0589 14 38C14 47.9411 22.0589 56 32 56Z" fill="#f43f5e" fillOpacity="0.7"/>
                  </svg>
                </div>
                <h1 className="text-3xl font-bold text-rose-600 text-center mb-2">Welcome to Think Mate</h1>
                <p className="text-lg text-rose-400 text-center mb-6">Build momentum, not just knowledge.</p>
                <button
                  className="w-full py-3 bg-rose-600 text-white font-semibold text-lg rounded-lg shadow hover:bg-rose-700 transition mb-4"
                  onClick={() => {
                    setFadeOut(true);
                    setTimeout(() => setShowSignup(true), 500);
                  }}
                >
                  Begin your journey &rarr;
                </button>
                <a
                  className="w-full text-rose-300 text-base underline hover:text-rose-400 mt-2 block text-center cursor-pointer"
                  href="/login"
                >
                  I already have an account
                </a>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default WelcomeModal; 